var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('UserReplacePassword',{ref:"UserReplacePasswordRef"}),(_vm.isPromptProfileVisible)?_c('PromptProfileDlg'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }